import * as THREE from 'three'

export interface Annotation {
  id: string
  position: THREE.Vector3
  text: string
  marker: THREE.Mesh
  label: THREE.Sprite
}

const sphereGeo = new THREE.SphereGeometry(0.04, 10, 10)
const sphereMat = new THREE.MeshBasicMaterial({ color: 0xff3333 })

let nextId = 1

export class AnnotationTool {
  annotations: Annotation[] = []
  private scene: THREE.Scene

  constructor(scene: THREE.Scene) {
    this.scene = scene
  }

  addAnnotation(position: THREE.Vector3, text = ''): Annotation {
    const id = `ann_${nextId++}`
    const marker = new THREE.Mesh(sphereGeo, sphereMat.clone())
    marker.position.copy(position)
    this.scene.add(marker)

    const label = this.createLabel(text || `标注 ${this.annotations.length + 1}`)
    label.position.copy(position)
    label.position.y += 0.08
    this.scene.add(label)

    const ann: Annotation = { id, position: position.clone(), text: text || `标注 ${this.annotations.length + 1}`, marker, label }
    this.annotations.push(ann)
    return ann
  }

  updateText(id: string, text: string) {
    const ann = this.annotations.find(a => a.id === id)
    if (!ann) return
    ann.text = text
    this.scene.remove(ann.label)
    ann.label = this.createLabel(text)
    ann.label.position.copy(ann.position)
    ann.label.position.y += 0.08
    this.scene.add(ann.label)
  }

  removeAnnotation(id: string) {
    const idx = this.annotations.findIndex(a => a.id === id)
    if (idx === -1) return
    const ann = this.annotations[idx]
    this.scene.remove(ann.marker)
    this.scene.remove(ann.label)
    this.annotations.splice(idx, 1)
  }

  getExportData(): { x: number; y: number; z: number; text: string }[] {
    return this.annotations.map(a => ({
      x: a.position.x, y: a.position.y, z: a.position.z, text: a.text,
    }))
  }

  clear() {
    for (const ann of this.annotations) {
      this.scene.remove(ann.marker)
      this.scene.remove(ann.label)
    }
    this.annotations = []
  }

  dispose() {
    this.clear()
  }

  private createLabel(text: string): THREE.Sprite {
    const W = 512
    const H = 128
    const canvas = document.createElement('canvas')
    canvas.width = W
    canvas.height = H
    const ctx = canvas.getContext('2d')!
    ctx.clearRect(0, 0, W, H)
    ctx.fillStyle = '#ff3333'
    ctx.font = 'bold 80px Consolas, monospace'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(text, W / 2, H / 2)
    const tex = new THREE.CanvasTexture(canvas)
    tex.minFilter = THREE.LinearFilter
    tex.magFilter = THREE.LinearFilter
    const mat = new THREE.SpriteMaterial({ map: tex, depthTest: false, depthWrite: false, sizeAttenuation: true, transparent: true })
    const sprite = new THREE.Sprite(mat)
    sprite.scale.set(2.0, 0.5, 1)
    return sprite
  }
}
